<template>
  <v-menu
    bottom
    right
    offset-y
    :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        color="#f7f7f7">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>
    <v-card max-width="300" tile>
      <v-list nav dense>
        <v-subheader>
          Portals
          <v-icon small class="ml-2">mdi-launch</v-icon>
        </v-subheader>
        <div class="portal-links-container">
          <v-list-item
            v-for="portal in availablePortals"
            :key="portal.key"
            class="portal-link"
            link
            @click="navigate(portal)"
            style="min-height: auto">
            <div class="portal-link-content">
              <v-btn
                plain
                icon
                class="mx-auto">
                <v-icon>{{ portal.icon }}</v-icon>
              </v-btn>
              <v-list-item-action-text class="pa-0 ma-0">
                {{ portal.name }}
              </v-list-item-action-text>
            </div>
          </v-list-item>
        </div>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
import { userAccess } from '@/mixins/user-access'
export default {
  name: 'PortalNavMenu',
  props: {
    active: String
  },
  mixins: [userAccess],
  computed: {
    portals () {
      return [
        { name: 'Ad Planner', key: 'adplan', icon: 'mdi-newspaper-variant-outline', show: !this.isARGVendor },
        { name: 'Billing', key: 'billing', icon: 'mdi-calendar-clock', show: !this.isARGVendor },
        { name: 'Customer', key: 'customer', icon: 'mdi-storefront', show: !this.isARGVendor },
        { name: 'Items', key: 'item', icon: 'mdi-barcode-scan', show: !this.isARGVendor },
        { name: ['jbg', 'alliance-retail-group'].includes(this.$auth.tenant) ? 'Documents' : 'Partner', key: 'partner', icon: 'mdi-folder-account-outline' },
        { name: 'Product Catalog', key: 'products', icon: 'mdi-package', tenants: ['jbg'] },
        { name: 'Promotions', key: 'promo', icon: 'mdi-tag-outline' },
        { name: 'TPR Manager', key: 'tpr', icon: 'mdi-account-tie-woman', tenants: ['awg', 'pricechopper','alliance-retail-group'], show: !this.isARGVendor }
      ].filter(p => p.show === undefined || p.show)
    },
    availablePortals () {
      let portals
      if (this.$auth.tenant === 'alliance-retail-group') {
        const portalKeyMap = {
          ad_planner: 'adplan',
          billing: 'billing',
          customer: 'customer',
          partner: 'partner',
          item: 'item',
          promo: 'promo',
          tpr: 'tpr'
        }
        const allowedKeys = this.userAccessiblePortals
          .map(portal => portalKeyMap[portal])
          .filter(portalKey => portalKey !== undefined)
        portals = this.portals.filter(portal => allowedKeys.includes(portal.key))
        return this.sortPortals(portals)
      }
      portals = this.portals.filter(portal => portal.tenants ? portal.tenants.includes(this.$auth.tenant) : true)
      return this.sortPortals(portals)
    },
    isARGVendor () {
      return this.$auth.userRoles.includes('arg-vendor')
    },
  },
  methods: {
    navigate (portal) {
      if (portal.key === this.active) return
      const url = this.buildPortalUrl(portal.key)
      window.location.href = url
    },
    buildPortalUrl (key) {
      let baseUrl = this.getPortalBaseUrl(key)
      let prefix = this.$auth.tenantURLPrefix
      if (prefix) {
        return `https://${prefix}.${baseUrl}`
      }
      return `https://${baseUrl}`
    },
    getPortalBaseUrl (key) {
      switch (key) {
        case 'adplan':
          return process.env.VUE_APP_ADPLAN_PORTAL
        case 'billing':
          return process.env.VUE_APP_BILLING_PORTAL
        case 'customer':
          return process.env.VUE_APP_CUSTOMER_PORTAL
        case 'item':
          return process.env.VUE_APP_ITEM_PORTAL
        case 'partner':
          return process.env.VUE_APP_PARTNER_PORTAL
        case 'products':
          return process.env.VUE_APP_PRODUCTS_PORTAL
        case 'promo':
          return process.env.VUE_APP_PROMO_PORTAL
        case 'tpr':
          return process.env.VUE_APP_TPR_PORTAL
        default:
          return ''
      }
    },
    sortPortals (portals) {
      return [...portals].sort((first, second) => first.name.localeCompare(second.name))
    },
  }
}
</script>
<style>
.portal-links-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 3px;
}

.portal-link {
  display: grid;
  justify-content: center;
  padding: 4px;
  height: 100%;
}

.portal-link-content {
  display: grid;
  justify-content: center;
  max-height: 53px;
  text-align: center;
}
</style>
